import React, { useState } from "react";
import PageHeader from "./PageHeader";
export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);

    // TODO: Call your backend API here
    alert("Thank you for contacting us! We’ll get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>
      <PageHeader seoKey={"contact"} />
      <section className="container py-5">
        <div className="row g-4">
          {/* Left: Contact Form */}
          <div className="col-lg-7">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4">
                <h2 className="fw-bold mb-4">Contact Us</h2>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Your Message</label>
                    <textarea
                      name="message"
                      className="form-control"
                      rows="5"
                      placeholder="Write your message..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary px-4">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>

          {/* Right: Contact Info + Google Map */}
          <div className="col-lg-5">
            <div className="card shadow-sm border-0 h-100">
              <div className="card-body p-4 d-flex flex-column">
                <h3 className="fw-bold mb-3">Get in Touch</h3>
                <p className="text-muted">
                  Have questions about our products or services? Reach out to us
                  using the form, or through the details below.
                </p>
                <ul className="list-unstyled flex-grow-1">
                  <li className="mb-3">
                    <i className="bi bi-geo-alt-fill text-primary me-2"></i>
                    Lahore, Pakistan
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-telephone-fill text-primary me-2"></i>
                    +92 311-7266767
                  </li>
                  <li className="mb-3">
                    <i className="bi bi-envelope-fill text-primary me-2"></i>
                    support@auraskinpremium.com
                  </li>
                </ul>

                {/* Google Map Embed */}
                <div className="mt-auto">
                  <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d108824.3660578498!2d74.2295207!3d31.5203696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190483e8efbc1b%3A0x9c056deb6c0e5f4f!2sLahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1695483928175!5m2!1sen!2s"
                    width="100%"
                    height="200"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
